import { Box, Typography } from "@mui/material";

type StatusCellProps = {
	isActive: boolean;
	label: string;
	isPending?: boolean;
};

export default function StatusCell({ isActive, label, isPending }: StatusCellProps) {
	const dotColor = isPending ? "warning.main" : isActive ? "success.main" : "text.disabled";

	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
			<Box
				sx={{
					width: 12,
					height: 12,
					borderRadius: "50%",
					flexShrink: 0,
					backgroundColor: dotColor
				}}
			/>
			<Typography variant="text14">{label}</Typography>
		</Box>
	);
}
